module.exports = __webpack_public_path__ + "static/media/product.6c628f9a.png";